import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook que protege rotas - redireciona para login se não houver token
 * Use em páginas que exigem autenticação
 */
export function useAuthGuard() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      console.log('🔐 Nenhum token encontrado. Redirecionando para login...');
      navigate('/auth');
    }
  }, [navigate]);
}
